export default __webpack_public_path__ + "static/media/card800.555ef7d6.jpg";